import { Module } from 'wrapper6';

export default class Navigation extends Module {
  ready() {
    this.NAV_TOGGLE = document.querySelector('#navigation-toggle');
    this.SEARCH = document.querySelector('#search');
    this.SEARCH_SUBMENU = document.querySelector('#searchsub');
    this.NAV_INNER_MENU = document.querySelector('.navigation-wrap--inner');
    this.NAV_SECONDARY = document.querySelector('#secondary-navigation');
    this.NAV_HAS_CHILDREN = document.querySelectorAll('.menu-item-has-children');
    this.NAV_EMPTY_LINKS = document.querySelectorAll('.navigation a[href="#"]');
    this.NAV_TRANSITION_DURATION = 500;
    this.NAV_TRANSITION = `transform ${this.NAV_TRANSITION_DURATION}ms ease, visibility ${this.NAV_TRANSITION_DURATION}ms ease`;
    this.NAV_TOGGLE_TRANSITION = 'background 0s 200ms';
    this.transitionTimeout;
    this.SEARCH_SHOW = false;

    this.init()
  }

  init() {
    window.addEventListener('click', (e) => {

      let contain = false;

      for (let i = 0; i <= e.composedPath().length -1; i++){
        const elem = e.composedPath()[i];
        if(elem.classList && elem.classList.contains('search')) {
          contain = true;
        }
      }

      if(!contain) {
        if (this.SEARCH_SHOW) {
          this.SEARCH_SUBMENU.classList.remove('show');
          this.SEARCH_SHOW = false;
        }
      }
    }, false);

    this.SEARCH.addEventListener('click', (e) => {

      let contain = false;

      for (let i = 0; i <= e.composedPath().length -1; i++){
        const elem = e.composedPath()[i];
        if(elem.classList && elem.classList.contains('sub-menu')) {
          contain = true;
        }
      }

      if(!contain) {
        if (this.SEARCH_SHOW) {
          this.SEARCH_SUBMENU.classList.remove('show');
          this.SEARCH_SHOW = false;
        } else {
          this.SEARCH_SUBMENU.classList.add('show');
          this.SEARCH_SHOW = true;
        }
      }
    }, false);

    this.NAV_TOGGLE.addEventListener('click', () => this.toggleNavigation(), false);

    for (let i = 0; i < this.NAV_HAS_CHILDREN.length; i++) {
      const EL = this.NAV_HAS_CHILDREN[i];
      EL.addEventListener('click', e => this.toggleSubMenu(e), true);
    }

    if (this.NAV_EMPTY_LINKS) {
      for (let i = 0; i < this.NAV_EMPTY_LINKS.length; i++) {
        const EL = this.NAV_EMPTY_LINKS[i];
        EL.addEventListener('click', e => e.preventDefault(), false);
      }
    }
  }

  openNavToggle() {
    this.NAV_TOGGLE.classList.add('open')
  }

  closeNavToggle() {
    this.NAV_TOGGLE.classList.remove('open')
  }

  openNavigation() {
    this.openNavToggle();
    this.handleTransition();
    this.NAV_INNER_MENU.classList.add('navigation-wrap--open');
  }

  closeNavigation() {
    this.closeNavToggle();
    this.handleTransition();
    this.NAV_INNER_MENU.classList.remove('navigation-wrap--open');
  }

  addTransition() {
    if (window.innerWidth > 800) {
      this.NAV_SECONDARY.style.transition = this.NAV_TRANSITION;
    } else {
      this.NAV_INNER_MENU.style.transition = this.NAV_TRANSITION;
    }

    this.NAV_TOGGLE.querySelector('div').style.transition = this.NAV_TOGGLE_TRANSITION;
  }

  removeTransition() {
    if (window.innerWidth > 800) {
      this.NAV_SECONDARY.style.transition = '';
    } else {
      this.NAV_INNER_MENU.style.transition = '';
    }

    this.NAV_TOGGLE.querySelector('div').style.transition = '';
  }
  
  handleTransition() {
    this.addTransition();
    clearTimeout(this.transitionTimeout);
    this.transitionTimeout = setTimeout(() => this.removeTransition(), this.NAV_TRANSITION_DURATION)
  }

  openSubMenu(e) {
    e.currentTarget.classList.add('open');
  }
  
  closeSubMenu(e) {
    e.currentTarget.classList.remove('open');
  }

  subMenuIsOpen(e) {
    return e.currentTarget.classList.contains('open');
  }

  get navIsOpen() {
    return this.NAV_TOGGLE.classList.contains('open');
  }

  toggleSubMenu(e) {
    let targetElement = (e.target.tagName.toLowerCase() === 'a' && e.target.href.indexOf('#') != -1) ? e.target.parentNode : e.target;

    if (targetElement.classList.contains('menu-item-has-children')) {
      e.preventDefault();
      this.subMenuIsOpen(e) ? this.closeSubMenu(e) : this.openSubMenu(e);
    }
  }

  toggleNavigation() {
    this.navIsOpen ? this.closeNavigation() : this.openNavigation();
  }
}